import { graphql } from 'gql';

export const exportActKC2TemplateAsExcelGql = graphql(`
    query uerExportActKC2TemplateAsExcel($input: ActKC2TemplateInput!, $workOrderId: Long!) {
        uerExportActKC2TemplateAsExcel(input: $input, workOrderId: $workOrderId) {
            data {
                count
                dataUrl
                name
                size
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
